const baseURL= "https://mernappbackend-kdry.onrender.com/api"

exports.baseURL = baseURL
